import { render } from "./TheImageManipulationSlider.vue?vue&type=template&id=6da19613"
import script from "./TheImageManipulationSlider.vue?vue&type=script&lang=ts"
export * from "./TheImageManipulationSlider.vue?vue&type=script&lang=ts"
script.render = render

export default script